export default __webpack_public_path__ + "media/react/b2b/app/pages/student/student_report/reading-fd07f17e9d58318b23c4b9d72b096fcd.svg";